/*
 * evdnce-okendo-fix.js
 * Keeps the Okendo reviews widget initialised on product pages.
 *
 * Why this exists:
 *   Okendo server-renders the first page of reviews as static HTML, then its
 *   bundle hydrates that markup — binding the "See more" pagination handler and
 *   lazy-loading the review media (customer photos + product thumbnails).
 *   On EVDNCE PDPs a later DOM re-render (Visually.io experiments / section
 *   reloads) replaces the reviews markup: the static review HTML survives, but
 *   Okendo's event handlers and image observers are lost. Result — reviews are
 *   visible, but "See more" does nothing and the images never load.
 *
 *   window.okeWidgetApi.initAllWidgets() re-binds everything (confirmed live),
 *   so this script simply re-runs it once the page settles and again whenever a
 *   fresh [data-oke-widget] container is inserted.
 */
(function () {
  'use strict';

  var REINIT_DELAY = 250; // ms — debounce, lets a re-render settle before we re-init
  var timer = null;

  function api() {
    return (window.okeWidgetApi && typeof window.okeWidgetApi.initAllWidgets === 'function')
      ? window.okeWidgetApi
      : null;
  }

  function hasWidget() {
    return !!document.querySelector('[data-oke-widget]');
  }

  function reinit() {
    var a = api();
    if (!a || !hasWidget()) return;
    try { a.initAllWidgets(); } catch (e) {}
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(reinit, REINIT_DELAY);
  }

  // Okendo's bundle loads async — wait until it exposes its API, then start.
  function whenReady(cb) {
    if (api()) { cb(); return; }
    var tries = 0;
    var iv = setInterval(function () {
      if (api()) { clearInterval(iv); cb(); }
      else if (++tries > 150) { clearInterval(iv); } // give up after ~30s
    }, 200);
  }

  whenReady(function () {
    // Initial safety kick (covers an early/missed auto-init), and again after load.
    schedule();
    window.addEventListener('load', schedule);

    // Re-fire only when a NEW widget container appears (i.e. the section markup
    // was re-rendered). Okendo's own internal updates mutate INSIDE the existing
    // container, which never matches/contains a fresh [data-oke-widget] node, so
    // normal pagination won't trigger a re-init loop.
    var scope = document.getElementById('MainContent') || document.body;
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue; // elements only
          if ((node.matches && node.matches('[data-oke-widget]')) ||
              (node.querySelector && node.querySelector('[data-oke-widget]'))) {
            schedule();
            return;
          }
        }
      }
    });
    observer.observe(scope, { childList: true, subtree: true });
  });
})();